import React, { Fragment } from 'react';
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Img from "react-cool-img";

import Linkify from 'react-linkify';
import { useTranslation } from 'react-i18next/hooks';

// import FilesUploadAction from '../../../FileUploadAction/FilesUploadAction';
import GroupTalkTextFile from '../GroupTalkTextFile/GroupTalkTextFile';
import GroupTalkTextFileKura from '../GroupTalkTextFile/GroupTalkTextFileKura';
// import GroupTalkTextModal from '../GroupTalkTextModal';
import GroupTalkTextItemSettings from './GroupTextItemSettings/GroupTextItemSettings';
import GroupTextItemReplyOri from './GroupTextItemReplyOri/GroupTextItemReplyOri';
import Loader from '../../../Loader/Loader';
// import SmallModal from '../../../Modal/SmallModal';
// import TransBackdrop from '../../../Backdrop/TransBackdrop';

import { useStore } from '../../../../hook-store/store';
import { getDateTime } from '../../../../util/timeFormat';
import { useOnScreen } from '../../../../custom-hooks/useOnScreen';

import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextItem.module.css';

import SampleImage from "../../../Image/person-icon-50.jpg";

const GroupTalkTextItem = (props) => {
  // console.log('GroupTalkTextItem-props', props);

  const { 
    inputData, 
    userId, 
    userColorList, 
    allMemberUserIds,
    groupTextReactions,
    createGroupTextReactionHandler,
    groupTextDeleteHandler,
    lsNameDataList,
    groupTextPostHandler,
    isTextPosting,
    isLoading,
   } = props;

  const [t] = useTranslation('translation');

  const itemFileRef = useRef();
  const isVisibleFileEl = useOnScreen(itemFileRef);
  
  const kuraFileIconRef = useRef();
  // if (isVisibleFileEl) {
  //   console.log('isVisibleFileEl', inputData?.text)
  // }

  const [store, dispatch] = useStore();
  const {
    selectedGroupData,
  } = store.groupStore;
  // console.log('store in GroupTalkTextItem', store);

  const [clickedTextId, setClickedTextId] = useState('');
  const [textReactions, setTextReactions] = useState([]);
  // const [replyTexts, setReplyTexts] = useState([]);
  const [showTextSettings, setShowTextSettings] = useState(false);
  
  // console.log(replyTexts);

  useEffect(() => {
    if (groupTextReactions.length > 0) {
      const textReactions = groupTextReactions.filter(reaction => {
        return reaction.groupTalkTextId === inputData._id;
      });
      // console.log('textReactions', textReactions);
  
      setTextReactions(textReactions);
    }
  },[groupTextReactions]);

  // useEffect(() => {
  //   if (selectedGroupData && selectedGroupData.talks && selectedGroupData.talks.length > 0) {
      
  //     const replyItems = [];
      
  //     for (const text of selectedGroupData.talks) {
  //       const replyInfo = text.replyInfo;

  //       if (replyInfo && replyInfo.originalTextId === inputData._id) {
  //         // console.log(replyInfo.originalTextId, inputData._id)
  //         replyItems.push(text);
  //       }

  //       if (replyItems.length > 0) {
  //         setReplyTexts(replyItems);
  //       }
  //     }
  //   }
  // },[selectedGroupData]);

  let userImageSrc;
  if (store.groupMemberImageUrls && store.groupMemberImageUrls.length > 0) {
    const userImageUrl = store.groupMemberImageUrls.find(iurl => {
      return iurl.userId === inputData.fromUserId;
    });

    if (userImageUrl) {
      userImageSrc = userImageUrl.imageUrl;
    }
  }
  // console.log('userImageSrc', userImageSrc, inputData)


  // console.log(groupTalkInputList);
  let elementStyle = "textTalk-listElement-remote";
  let colorStyle = null;

  if (inputData.fromUserId === userId) {
    elementStyle = "textTalk-listElement-local"
    colorStyle={ 
      color: 'var(--color)',
      border: '0.5px solid lightgray',
     }
  }

  // console.log('allMemberUserIds', allMemberUserIds);
  if (inputData.fromUserId !== userId && allMemberUserIds.length > 0
  ) {
    const userColorElement = allMemberUserIds.find(element => {
      return element.userId === inputData.fromUserId;
    });
    // console.log('userColorElement', userColorElement, inputData.fromUserId);
    
    if (userColorElement) {
      colorStyle = {
        // color: 'black', 
        // backgroundColor: userColorElement.bgColor,
        border: `1px solid ${userColorElement.userColor}`,
      };
    } else {
      colorStyle = {
        // color: 'black', 
        // backgroundColor: userColorElement.bgColor,
        border: `1px solid lightgray`,
      };
    }
  }



    // const lsDarkMode = localStorage.getItem('darkMode');
    // if (lsDarkMode) {
    //   colorStyle = null;
    // }

    // console.log('darkMode, colorStyle', localStorage.getItem('darkMode'), colorStyle);
    // console.log('userColor[0]', userColorList[0].bgColor);
  const sendTime = new Date(inputData.sendAt);

  let [month, date, year] = (new Date(inputData.sendAt)).toLocaleDateString().split("/")
  let [hour, minute, second] = (new Date(inputData.sendAt)).toLocaleTimeString().slice(0, 7).split(":")
  let xm = (new Date(inputData.sendAt)).toLocaleTimeString().split(' ')[1];
  

  let nameData;
  if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
    nameData = JSON.parse(lsNameDataList).find(ele => {
      return ele.userId === inputData.fromUserId;
    });
  }

  // console.log(nameData)

  const componentDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank" rel="noopener noreferrer" style={{color: 'gray', fontWeight: ''}}>
        {text}
    </a>
  );


  let talkUserImageEl;
  
  if (nameData && nameData.imageUrl) {
    talkUserImageEl = (
      <Img className={classes.groupTalkTextItmeUserImage}
      // style={{height: "1rem", width: "1rem", objectFit: "cover"}}
        title={nameData.name}
        src={nameData.imageUrl} 
      />
    );
  } else {
    talkUserImageEl = (
      <Img className={classes.groupTalkTextItmeUserImage}
        // style={{height: "1rem", width: "1rem", objectFit: "cover"}}
        title={nameData?.name}
        src={SampleImage} 
      />
    );
  }


  let talkElementBody;
  
  const talkElement = (
    <div className={elementStyle} style={colorStyle}>
      <div>
        <GroupTextItemReplyOri
          inputData={inputData}
          userId={userId} 
          allMemberUserIds={allMemberUserIds}
          lsNameDataList={lsNameDataList}
        />
      </div>

      <span       
        ref={itemFileRef}
      >
        {!inputData.kuraFileInfo?.key && (
          <GroupTalkTextFile 
            inputData={inputData}
          />
        )}
        {inputData.kuraFileInfo?.key && (
          <GroupTalkTextFileKura
            inputData={inputData}
            isVisibleFileEl={isVisibleFileEl}
            kuraFileIconRef={kuraFileIconRef}
          />
          // <div>kura-file</div>
        )}
      </span>

      <div className="textTalk-listElement-text">
      <Linkify componentDecorator={componentDecorator}>
        {inputData.text}
      </Linkify>
      </div>

      <div className={classes.groupTalkTextItmeName}>
        <span className={classes.groupTalkTextItmeNameElement}>
          {/* {inputData.fromName} */}
          {localStorage.getItem('userId') && nameData && (
            <span> 
              {nameData.name}
            </span>
          )}
        </span>
        {userImageSrc &&
          <span className={classes.groupTalkTextItmeNameElement}>
            {/* <Img
              className={classes.groupTalkTextItmeNameImage}
              src={userImageSrc} 
              // height="12.5" 
              alt='user-img' 
            />  */}
            {localStorage.getItem('userId') && nameData?.imageUrl && (
              <Img className={classes.groupTalkTextItmeNameImage}
                // style={{height: "1rem", width: "1rem", objectFit: "cover"}}
                src={nameData.imageUrl} 
              />
            )}
            {/* {localStorage.getItem('userId') && !nameData?.imageUrl && (
              <Img className={classes.grupInfoMemberListImage}
                // style={{height: "1rem", width: "1rem", objectFit: "cover"}}
                src={SampleImage} 
              />
            )} */}
          </span>
        }

        {/* <span className={classes.groupTalkTextItmeTimeElement}>
          ({month}/{date} {hour}:{minute} {xm})
        </span> */}
      </div>

      <div className={classes.groupTalkTextItmeTimeElement}>
          {/* {month}/{date} {hour}:{minute} {xm} */}
          {getDateTime(sendTime)}
      </div>


      <div className={classes.groupTalkTextItemReactionButtonsContainer}>
        <span
          className={classes.groupTalkTextItemReactionButton} 
          role="img" aria-label="thumbs-up" 
          disabled={isLoading}
          onClick={() => {
            createGroupTextReactionHandler(
              userId, 
              inputData.groupRoomId, 
              inputData._id, 
              'like'
            );
            setClickedTextId(inputData._id);
          }}
        >
          &#128077;
        </span>
        <span>
          {textReactions && textReactions.length > 0 && <span> {textReactions.length}</span>}
          {clickedTextId === inputData._id && isLoading && <Loader loaderStyle="loaderSmall" />}
        </span>
      </div>

      {/* {replyTexts && replyTexts.length > 0 && (
        <div>
          <span
            onClick={() => {
              setShowTextSettings(!showTextSettings)
            }}
          >
            Reply {replyTexts.length}
          </span>
        </div>
      )} */}
      
      {userId && (
        <div className={classes.groupTalkTextItemRow}>
          <GroupTalkTextItemSettings 
            inputData={inputData} 
            userId={userId} 
            userColorList={userColorList}
            allMemberUserIds={allMemberUserIds}
            groupTextDeleteHandler={groupTextDeleteHandler}
            groupTextPostHandler={groupTextPostHandler}
            isTextPosting={isTextPosting}
            lsNameDataList={lsNameDataList}
            // replyTexts={replyTexts}
            showTextSettings={showTextSettings}
            setShowTextSettings={setShowTextSettings}
            kuraFileIconRef={kuraFileIconRef}
            isLoading={isLoading}
          />
        </div>
      )}
    </div>
  );


  
  if (inputData.fromUserId === userId) {
    talkElementBody = (
      <span>
        <div className={classes.groupTalkTextItmeUserImageRow}>
          <span></span>
          <span>{talkUserImageEl}</span>
        </div>
        <div
          className="textTalk-listElement-container"
        >
          <div></div>
          {talkElement}
        </div>
      </span>
    );
  } else {
    talkElementBody = (
      <span>
        <div className={classes.groupTalkTextItmeUserImageRow}>
          <span>{talkUserImageEl}</span>
          <span></span>
        </div>
        <div 
          className="textTalk-listElement-container"
        >
          {talkElement}
          <div></div>
        </div>
      </span>
    );
  }

 
  return (
    <Fragment>
      {talkElementBody}
    </Fragment>
  );
}

export default GroupTalkTextItem;